const ENV = {
  MANDATE_RETRY_COUNT_LIMIT: parseInt(
    process.env.NEXT_PUBLIC_MANDATE_RETRY_COUNT_LIMIT
  ),
  AA_CUM_PERFIOS_MAX_LIMIT: parseInt(
    process.env.NEXT_PUBLIC_AA_CUM_PERFIOS_MAX_LIMIT
  ),
  MAX_UPI_MANDATE_RETRY_COUNT:5,
  MAX_E_MANDATE_RETRY_COUNT:5
};

export default ENV;
